import { importsByIdStatusGetSlice } from './get';

export const {
	requestGetImportsByIdStatus,
	resetGetImportsByIdStatus
} = importsByIdStatusGetSlice.asyncActionCreators;
